export const lowerCaseRegex = /[a-z]/;
export const upperCaseRegex = /[A-Z]/;
export const numberRegex = /\d/;
export const specialCharacterRegex = /\W|_/;
